import React, { useState } from "react";
import DocumentModal from "./DocumentModal";
import arrow from "../../images/home/white-Arrow.svg";

const Resources = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const handleDocumentClick = (document) => {
    setSelectedDocument(document);
    setIsModalOpen(true);
  };

  const resourceCategories = [
    {
      id: 1,
      title: "About Company",
      description: "Learn more about us and find out about services, how we work and our commitments about immigration advice.",
      documents: [
        {
          id: "company-1",
          name: "Company Overview",
          filename: "Company Overview.pdf",
          description: "Learn more about ImmigetGlobal and our immigration services"
        },
        {
          id: "company-2", 
          name: "Migration Services",
          filename: "Migration Services Overview.pdf",
          description: "Comprehensive overview of our migration services and offerings"
        },
        {
          id: "company-3",
          name: "Quick View",
          filename: "Quick View.pdf",
          description: "Quick overview of our services and how we can help you"
        }
      ]
    },
    {
      id: 2,
      title: "Employer Sponsor visa (ESV)",
      description: "Find easy checklists, guides, and info to help businesses and skilled workers with the Employer Sponsored visa program.",
      documents: [
        {
          id: "esv-1",
          name: "ESV Highlights",
          filename: "ESV Highlights.pdf", 
          description: "Key highlights and benefits of the Employer Sponsored visa program"
        },
        {
          id: "esv-2",
          name: "ESV Brief Overview",
          filename: "ESV Brief Overview.pdf",
          description: "Brief overview of the Employer Sponsored visa process and requirements"
        },
        {
          id: "esv-3",
          name: "ESV Options", 
          filename: "ESV Options.pdf",
          description: "Different options available under the Employer Sponsored visa program"
        },
        {
          id: "esv-4",
          name: "Employer Sponsorship Checklist",
          filename: "Employer Sponsorship Checklist.pdf",
          description: "Complete checklist for employers looking to sponsor skilled workers"
        },
        {
          id: "esv-5",
          name: "Mining Sector Visa Success Story",
          filename: "Mining Sector Visa Success Story.pdf",
          description: "Success story from the mining sector showing ESV outcomes"
        }
      ]
    },
    {
      id: 3,
      title: "Additional Immigration Resources",
      description: "Find additional information and helpful resources for the immigration process.",
      documents: [
        {
          id: "resources-1",
          name: "Move to Australia: A Guide for UK GPs",
          filename: "Move to Australia A Guide for UK GPs.pdf",
          description: "Comprehensive guide for UK General Practitioners moving to Australia"
        },
        {
          id: "resources-2",
          name: "Settle In Australia as an Indian Doctor",
          filename: "Settle In Australia as an Indian Doctor.pdf",
          description: "Guide for Indian doctors on settling and practicing in Australia"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[24px] md:text-[54px]">
              Immigration Resources
            </div>
            <div className="text-white hellix-font text-center text-sm md:text-xl mb-6 max-w-3xl mx-auto">
              Access essential guides, forms, and documents to support your Australian immigration journey
            </div>
            <div className="flex justify-center items-center space-x-4">
              <div className="w-12 h-1 bg-white rounded"></div>
              <span className="text-white text-sm hellix-font font-medium">FREE DOWNLOADS</span>
              <div className="w-12 h-1 bg-white rounded"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Resources Categories */}
      <div className="py-16">
        <div className="container max-w-[1440px] mx-auto px-4 xl:px-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-8">
            {resourceCategories.map((category) => (
              <div 
                key={category.id}
                className="bg-white rounded-2xl shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300"
              >
                <div className="p-8">
                  <h3 className="hellix-font text-2xl font-bold text-blue-900 mb-4">
                    {category.title}
                  </h3>
                  <p className="hellix-font text-gray-600 mb-6">
                    {category.description}
                  </p>
                  
                  <div className="space-y-4">
                    {category.documents.map((document) => (
                      <div 
                        key={document.id}
                        className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:bg-blue-50 transition-all duration-200 cursor-pointer"
                        onClick={() => handleDocumentClick(document)}
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <h4 className="hellix-font font-semibold text-blue-900 mb-2">
                              {document.name}
                            </h4>
                            <p className="hellix-font text-sm text-gray-600 leading-relaxed">
                              {document.description}
                            </p>
                          </div>
                          <div className="ml-4 flex-shrink-0">
                            <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center mt-3 text-blue-600">
                          <span className="hellix-font text-sm font-medium">Click to download</span>
                          <svg className="w-4 h-4 ml-2" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M9,16.17L4.83,12L3.41,13.41L9,19L21,7L19.59,5.59L9,16.17Z" />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Additional Info Section */}
      <div className="bg-white py-16 border-t border-gray-200">
        <div className="container max-w-[1440px] mx-auto px-4 xl:px-14 text-center">
          <h3 className="hellix-font text-3xl font-bold text-blue-900 mb-4">
            Need Personalized Assistance?
          </h3>
          <p className="hellix-font text-gray-700 text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            While these resources provide valuable information, every immigration case is unique. 
            Our experienced consultants are here to provide personalized guidance tailored to your specific situation.
          </p>
          <div className="flex justify-center">
            <button className="relative w-[200px] xl:w-[220px] text-center justify-center group text-[#004b6b] hellix-font font-bold text-[16px] h-[50px] xl:h-[56px] rounded-[28px] flex items-center space-x-2 border-2 border-blue overflow-hidden">
              {/* Background Animation */}
              <span className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-all duration-1000 ease-in-out origin-left z-0"></span>

              {/* Button Content */}
              <span className="relative z-10 group-hover:text-blue transition-colors duration-700 ease-in">
                <a href="/immigration-office-australia-consultants">
                  Schedule Consultation
                </a>
              </span>

              <img
                src={arrow}
                alt="Arrow Icon"
                className="relative z-10 transition-all duration-500 ease-in group-hover:ml-3 group-hover:filter group-hover:invert group-hover:sepia group-hover:saturate-200 group-hover:hue-rotate-0 group-hover:contrast-105 w-[14px]"
              />
            </button>
          </div>
          
          {/* Additional Contact Options */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center text-sm text-gray-600">
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
              </svg>
              <span>Free Initial Consultation</span>
            </div>
            <div className="hidden sm:block text-gray-300">•</div>
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M10,11H12.5V16H14.5V11H17L12,6L7,11H10Z" />
              </svg>
              <span>Expert Migration Agents</span>
            </div>
            <div className="hidden sm:block text-gray-300">•</div>
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.8,20C17.4,21.2 16.3,22 15,22H5C3.3,22 2,20.7 2,19V18C2,17.4 2.4,17 3,17C3.6,17 4,17.4 4,18V19C4,19.6 4.4,20 5,20H15C15.6,20 16,19.6 16,19V5C16,4.4 15.6,4 15,4H5C4.4,4 4,4.4 4,5V6C4,6.6 3.6,7 3,7C2.4,7 2,6.6 2,6V5C2,3.3 3.3,2 5,2H15C16.3,2 17.4,2.8 17.8,4H19C20.7,4 22,5.3 22,7V17C22,18.7 20.7,20 19,20H17.8Z" />
              </svg>
              <span>Personalized Solutions</span>
            </div>
          </div>
        </div>
      </div>

      {/* Document Download Modal */}
      <DocumentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        document={selectedDocument}
      />
    </div>
  );
};

export default Resources;